import { createEvent } from "effector";
const OnStartFetchDataEvt = () => {
    const onStartFetchDataEvt = createEvent("OnStartFetchDataEvt");
    onStartFetchDataEvt.watch(() => console.log("OnStartFetchDataEvt"));
    return onStartFetchDataEvt;
};
export default OnStartFetchDataEvt;
//# sourceMappingURL=OnStartFetchDataEvt.js.map